import React, { useState } from 'react';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import Beranda from '../pages/Beranda';
import JourneyTracker from '../pages/JourneyTracker';
import SmartEscrow from '../pages/SmartEscrow';
import Komunitas from '../pages/Komunitas';
import Toko from '../pages/Toko';

export default function Dashboard({ theme, toggleTheme, onLogout, user }) {
  const [currentPage, setCurrentPage] = useState('beranda');
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const renderPage = () => {
    switch (currentPage) {
      case 'beranda': return <Beranda />;
      case 'tracker': return <JourneyTracker />;
      case 'escrow': return <SmartEscrow />;
      case 'komunitas': return <Komunitas />;
      case 'toko': return <Toko />;
      default: return <Beranda />;
    }
  };

  return (
    <div className="dark:bg-[#0E0E12] bg-[#F7FAFC] min-h-screen flex font-poppins">
      {/* Mobile overlay */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-[#0E0E12]/60 z-30 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Sidebar */}
      <Sidebar
        currentPage={currentPage}
        setCurrentPage={(page) => { setCurrentPage(page); setSidebarOpen(false); }}
        sidebarOpen={sidebarOpen}
        user={user}
        onLogout={onLogout}
      />

      {/* Main Content */}
      <div className="flex-1 flex flex-col min-w-0 lg:ml-60">
        <TopBar
          theme={theme}
          toggleTheme={toggleTheme}
          onLogout={onLogout}
          user={user}
          currentPage={currentPage}
          setSidebarOpen={setSidebarOpen}
        />
        <main data-testid="dashboard-main" className="flex-1 p-4 sm:p-6 overflow-auto">
          <div key={currentPage} className="animate-fade-in">
            {renderPage()}
          </div>
        </main>
      </div>
    </div>
  );
}
